import svgPaths from "./svg-ke7pij85le";

export default function ArrowDropDown() {
  return (
    <div className="relative size-full" data-name="arrow_drop_down">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
      >
        <g id="arrow_drop_down">
          <path
            d={svgPaths.p3611aa00}
            fill="var(--fill-0, #4A5565)"
            id="icon"
          />
        </g>
      </svg>
    </div>
  );
}
